import React from 'react';
import LegalLayout from './LegalLayout';

/**
 * Impressum (§ 5 ECG / § 14 UGB / § 25 Mediengesetz / Spanish LSSI).
 *
 * Real Content is a product of REALTECHSOLUTIONS, S.L. (Spanish
 * company). The Austrian audience makes the .at domain + DE-language
 * presentation the right surface. But legally we have to disclose the
 * Spanish company. Information sits in standard Impressum order; not
 * highlighted, not hidden.
 */
export default function ImpressumPage() {
  return (
    <LegalLayout title="Impressum">
      <p>
        Angaben gemäß § 5 ECG, § 14 UGB und § 25 Mediengesetz:
      </p>

      <h2>Diensteanbieter</h2>
      <p>
        <strong>REALTECHSOLUTIONS, S.L.</strong><br />
        Handelsname: <strong>Real Content</strong><br />
        Calle Galicia, Num 9, Bloque B, Planta Baja, Puerta 3<br />
        35660 Corralejo, La Oliva<br />
        Fuerteventura, Las Palmas, Spanien
      </p>

      <h2>Kontakt</h2>
      <p>
        E-Mail: <a href="mailto:info@real-content.at">info@real-content.at</a><br />
        Support: <a href="mailto:support@real-content.at">support@real-content.at</a>
      </p>

      <h2>Unternehmensgegenstand</h2>
      <p>
        Bereitstellung einer SaaS-Plattform zur automatisierten Erstellung
        und Veröffentlichung von Immobilien-Videos auf sozialen Netzwerken
       . Primär für Maklerinnen und Makler im deutschsprachigen Raum.
      </p>

      <h2>Handelsregister</h2>
      <p>
        Eingetragen im Handelsregister von Las Palmas<br />
        CIF: B16358327<br />
        Verwaltet von AEAT 35018 Fuerteventura
      </p>

      <h2>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
      <p>
        REALTECHSOLUTIONS, S.L.<br />
        Calle Galicia, Num 9, Bloque B, Planta Baja, Puerta 3<br />
        35660 Corralejo, La Oliva, Fuerteventura, Spanien
      </p>

      <h2>Online-Streitbeilegung</h2>
      <p>
        Die Europäische Kommission stellt eine Plattform zur
        Online-Streitbeilegung (OS) bereit:
        {' '}
        <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer noopener">
          https://ec.europa.eu/consumers/odr
        </a>
        . Wir sind nicht bereit oder verpflichtet, an
        Streitbeilegungsverfahren vor einer
        Verbraucherschlichtungsstelle teilzunehmen.
      </p>

      <h2>Haftungsausschluss</h2>
      <p>
        Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt.
        Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte
        können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter
        sind wir gemäß § 7 Abs. 1 TMG und Art. 14, 15 ECG für eigene
        Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
        verantwortlich. Nach §§ 8 bis 10 TMG bzw. Art. 16, 17 ECG sind
        wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte
        oder gespeicherte fremde Informationen zu überwachen oder nach
        Umständen zu forschen, die auf eine rechtswidrige Tätigkeit
        hinweisen.
      </p>
    </LegalLayout>
  );
}
